import { FC } from 'react'

interface DiffEntry { before: unknown; after: unknown }

const isDiffEntry = (v: any): v is DiffEntry =>
  v !== null && typeof v === 'object' && 'before' in v && 'after' in v

const renderValue = (value: unknown): string => {
  if (value === null || value === undefined) return '—'
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}

interface Props {
  action: string
  changes: Record<string, unknown> | null
}

export const DiffTable: FC<Props> = ({ action, changes }) => {
  if (!changes || Object.keys(changes).length === 0) {
    return <p className="nb-audit-drawer__row-label">No field-level changes recorded.</p>
  }

  const entries = Object.entries(changes)
  const allDiffShape = entries.every(([, v]) => isDiffEntry(v))

  if (action === 'updated' && allDiffShape) {
    return (
      <table className="nb-audit-drawer__diff-table">
        <thead>
          <tr>
            <th>Field</th>
            <th>Before</th>
            <th>After</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(([field, val]) => {
            const d = val as DiffEntry
            return (
              <tr key={field}>
                <td>{field}</td>
                <td className="nb-audit-drawer__before">{renderValue(d.before)}</td>
                <td className="nb-audit-drawer__after">{renderValue(d.after)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  // Created / deleted / anything else → JSON snapshot (before-only or after-only from build_diff).
  const snapshot: Record<string, unknown> = {}
  entries.forEach(([k, v]) => {
    if (isDiffEntry(v)) {
      snapshot[k] = action === 'deleted' ? v.before : v.after
    } else {
      snapshot[k] = v
    }
  })
  return <pre className="nb-audit-drawer__snapshot">{JSON.stringify(snapshot, null, 2)}</pre>
}
